





















import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class SelectTermComponent extends Vue {
  @Prop({ default: 0 })
  deadline!: number

  @PropSync("startOn", { type: String, default: "", required: true })
  syncStartOn!: string

  @PropSync("endOn", { type: String, default: "", required: true })
  syncEndOn!: string

  disabled = true

  mounted() {
    this.onChangeDateType()
  }

  /**
   * 今月を取得
   */
  private get thisMonth() {
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
    return now.getUTCMonth() + 1
  }

  @Watch("deadline")
  onChangeDateType() {
    if (this.deadline === 0) {
      this.syncStartOn = ""
      this.syncEndOn = ""
      this.disabled = true
      return
    }

    /* 現在日時を日本時間にずらす */
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
    
    const startOn = new Date(now.getTime())
    const endOn = new Date(now.getTime())

    /* 期間をセット */
    if (this.deadline === 31) {
      /* 月末締 */
      if (25 > now.getDate()) { // 25日以降(2/28が月末&日曜の場合の最終金曜日)の場合は、当月分の請求と判断
        /* 先月 */
        startOn.setUTCMonth(startOn.getUTCMonth() - 1, 1)
        endOn.setUTCDate(0)
      } else {
        /* 今月 */
        startOn.setUTCDate(1)
        endOn.setUTCMonth(endOn.getUTCMonth() + 1, 0)
      }
    } else {
      /* 月末締以外 */
      if (now.getDate() >= this.deadline) {
        /* 今月 */
        startOn.setUTCMonth(startOn.getUTCMonth() - 1, this.deadline + 1)
        endOn.setUTCDate(this.deadline)
      } else {
        /* 先月 */
        startOn.setUTCMonth(startOn.getUTCMonth() - 2, this.deadline + 1)
        endOn.setUTCMonth(endOn.getUTCMonth() - 1, this.deadline)
      }
    }

    /* 期間を選択値に変更 */
    this.syncStartOn = startOn.toISOString().substr(0, 10)
    this.syncEndOn = endOn.toISOString().substr(0, 10)
    this.disabled = false
 }
}
